























































































































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import AdminContentItemShowTabular from '@/modules/content-item/components/admin/AdminContentItemShowTabular.vue'
import { ContentItemResourceType } from '@/modules/content-item/models/content-item-resource.model'
import AdminLayout from '@/modules/common/layout/components/admin/AdminLayout.vue'
import ContentItemInformationTable from '@/modules/content-item/components/shared/ContentItemInformationTable.vue'
import AdminUserInfoButton from '@/modules/user/components/admin/AdminUserInfoButton.vue'
import AdminContentItemDownloadContent from '@/modules/content-item/components/admin/AdminContentItemDownloadContent.vue'
import SimpleHeader from '@/modules/shared/components/shared/SimpleHeader.vue'
import AdminContentItemFinancialTable from '@/modules/content-item/components/admin/table/AdminContentItemFinancialTable.vue'
import AdminContentItemUpdateAttributes from '@/modules/content-item/components/admin/AdminContentItemUpdateAttributes.vue'
import AdminContentItemSendToReview from '@/modules/content-item/components/admin/AdminContentItemSendToReview.vue'
import AdminChangelogTable from '@/modules/changelog/components/admin/AdminChangelogTable.vue'
import AdminContentItemShowSideNavigation from '@/modules/content-item/components/admin/AdminContentItemShowSideNavigation.vue'
import ContentHeadingsTable from '@/modules/content/components/shared/ContentHeadingsTable.vue'
import ContentImagesTable from '@/modules/content/components/shared/ContentImagesTable.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { path } from '@/modules/shared/helpers/utils/utils'
import { AdminContentItemSaveContentUseCase } from '@/modules/content-item/use-cases/admin/admin-content-item-save-content.use-case'
import { ContentItemSaveContentRequestModelInAdmin } from '@/modules/content-item/models/content-item-request.model'
import AdminContentEditor from '@/modules/content/components/admin/AdminContentEditor.vue'
import AdminContentItemDateTable from '@/modules/content-item/components/admin/AdminContentItemDateTable.vue'
import UrlWrapper from '@/modules/shared/components/shared/UrlWrapper.vue'

@Component({
  layout: AdminLayout,
  layoutProps: {
    page_header: 'آیتم تولید محتوا'
  },
  metaInfo: {
    title: 'آیتم تولید محتوا'
  },
  components: {
    UrlWrapper,
    AdminContentItemDateTable,
    AdminContentEditor,
    BaseButton,
    AdminContentItemShowSideNavigation,
    AdminContentItemSendToReview,
    AdminContentItemShowTabular,
    AdminContentItemInformationTable: ContentItemInformationTable,
    AdminUserInfoButton,
    AdminContentItemDownloadContent,
    AdminContentItemUpdateAttributes,
    ContentItemInformationTable,
    SimpleHeader,
    AdminContentItemFinancialTable,
    AdminChangelogTable,
    ContentHeadingsTable,
    ContentImagesTable
  }
})
export default class ContentItemShowPage extends Vue {
  constructor(private readonly saveContentUseCase: AdminContentItemSaveContentUseCase) {
    super()
  }

  @Prop() contentItem: ContentItemResourceType

  private content: string = path(['content', 'content'], this.contentItem.data, '')

  private wordCount: number = path(['content', 'word_count'], this.contentItem.data, 0)

  private lead: string = path(['content', 'lead'], this.contentItem.data, '')

  private title: string = path(['content', 'title'], this.contentItem.data, this.contentItem.data.title)

  get hasWriter() {
    return this.contentItem.data.writer !== null
  }

  get hasEditor() {
    return this.contentItem.data.editor !== null
  }

  private saveContent() {
    const data: ContentItemSaveContentRequestModelInAdmin = {
      title: this.title,
      content: this.content,
      word_count: this.wordCount,
      lead: this.lead
    }

    this.saveContentUseCase.execute(this.contentItem.data.id, data)
  }

  private wordsEventHandler(value: number) {
    this.wordCount = value
  }

  get dates(): Array<{ key: string; value: string }> {
    let dates = []
    Object.entries(this.contentItem.data).map(item => {
      if (item[0].includes('_at')) {
        dates.push({ key: item[0], value: item[1] })
      }
    })
    dates.pop() //pop created_at
    return dates
  }
}
